const DURATION = 1.5;

class FaceInScroll {
  constructor() {
    // 普通のやつ
    gsap.utils.toArray(".js-fade-in-scroll").forEach((elm) => {
      ScrollTrigger.create({
        trigger: elm,
        once: true,
        start: "top-=100px center",
        // markers: true,
        onEnter: () => {
          gsap.to(elm, {
            autoAlpha: 1,
            y: 0,
            duration: DURATION,
          });
        },
      });
    });

    // リスト
    gsap.utils.toArray(".js-fade-in-scroll-ul").forEach((elm) => {
      const delay = elm.dataset.delay ? Number(elm.dataset.delay) : 0.2;
      const delayMax = elm.dataset.delayMax ? Number(elm.dataset.delayMax) : 3;

      ScrollTrigger.create({
        trigger: elm,
        once: true,
        start: "top-=100px center",
        // markers: true,
        onEnter: () => {
          const $list = elm.querySelectorAll(".js-fade-in-scroll-li");
          gsap.utils.toArray($list).forEach((elm2, index) => {
            gsap.to(elm2, {
              autoAlpha: 1,
              y: 0,
              duration: DURATION,
              delay: Math.min(delayMax, index * delay),
            });
          });
        },
      });
    });
  }
}

export { FaceInScroll };
